import { isNotUndefined } from 'effect/Predicate'

export type With<T, K extends keyof T> = T & { [P in K]-?: Exclude<T[P], undefined> }

export const withProperty = <T extends object, K extends keyof T>(value: T, key: K): value is With<T, K> =>
  isNotUndefined(value[key])
